(function ($) {
  'use strict';

  /**
   * Paper Borders - Position Randomizer
   * - Helps borders look a lil more varied & avoids repeats.
   * - Adds a randomly generated border offset var to a given el
   *   & falls back to `0rem` offset via authored CSS.
   * - Defaults to `px` values if no unit is set.
   */

  var $section_borders = $('[data-random-border-width]');

  $section_borders.each(function () {
    var $this = $(this);
    // Pasre width as str using `.attr()`
    var borderWidth = $this.attr( 'data-random-border-width' );
    // Get width value & unit from str
    var borderWidthVal = parseVal( borderWidth );

    if ( borderWidthVal ) {
      var offset_val = randomBorderOffset( borderWidthVal['val'], borderWidthVal['unit'] );
      $this.css( '--border-offset', offset_val );
    }
  });

  // Generate random border offset based on image width
  // - Defaults to 'px' values
  function randomBorderOffset( borderWidth, unit ) {
    unit = unit !== '' ? unit : 'px';
    return randomInt( 0, borderWidth ) + unit;
  }

  // Get random int between 2 vals
  function randomInt( min, max ) {
    return Math.floor( Math.random() * ( max - min ) ) + min;
  }

  // Get raw value & unit from string
  // - Ex. '1.125rem', '1200px', '20'
  function parseVal( str ) {
    var matches = str.match( /(-?[\d.]+)([a-z%]*)/ );

    if ( matches !== null ) {
      return {
        val: parseFloat( matches[1] ),
        unit: matches[2],
      };
    }

    return false;
  }

})(jQuery);
